export enum RealtimeType {
    checkpoints = 'checkpoints',
    checkpoint_results = 'checkpointResults',
    companies = 'companies',
    leaves = 'leaves',
    platforms = 'platforms',
    users = 'users',
}
